import React, { useEffect } from 'react';
import { initPixel, trackPageView } from './utils/pixel';
import { Hero } from './components/Hero';
import { OpeningHook } from './components/OpeningHook';
import { ProblemSection } from './components/ProblemSection';
import { WhyItFailed } from './components/WhyItFailed';
import { MechanismSection } from './components/MechanismSection';
import { WhatYouGet } from './components/WhatYouGet';
import { WhoIsFor } from './components/WhoIsFor';
import { HowItWorks } from './components/HowItWorks';
import { ProofSection } from './components/ProofSection';
import { FAQ } from './components/FAQ';
import { PricingCTA } from './components/PricingCTA';
import { Footer } from './components/Footer';
import { Divider } from './components/Divider';
export function App() {
  useEffect(() => {
    initPixel('1617656212633912');
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-dark text-cream font-sans selection:bg-gold/30 selection:text-gold-light" data-id="element-0">
      <Hero data-id="element-1" />
      <OpeningHook data-id="element-2" />
      <Divider data-id="element-3" />
      <ProblemSection data-id="element-4" />
      <WhyItFailed data-id="element-5" />
      <Divider data-id="element-6" />
      <MechanismSection data-id="element-7" />
      <WhatYouGet data-id="element-8" />
      <Divider data-id="element-9" />
      <WhoIsFor data-id="element-10" />
      <HowItWorks data-id="element-11" />
      <ProofSection data-id="element-12" />
      <Divider data-id="element-13" />
      <FAQ data-id="element-14" />
      <PricingCTA data-id="element-15" />
      <Footer data-id="element-16" />
    </div>;
}